import { localization } from "../localizationManager";

export var arabicStrings = {
  groupButton : "زرار المجموعة",
  ungroupButton : "تم التحديث من خلالى",
  selectButton : "اختر",
  hideColumn : "اخفاء العمود",
  showColumn : "اظهار",
  makePrivateColumn : "أجعل العمود خاص",
  makePublicColumn : "أجعل العمود عام",
  moveToDetail : "انتقل إلى التفاصيل",
  showAsColumn : "إظهار كعمود",
  filterPlaceholder : "بحث...",
  removeRows : "حذف",
  showLabel : "اظهار",
  entriesLabel : "مدخلات",
  visualizer_text : "جداول",
  visualizer_wordcloud : "كلمات",
  visualizer_histogram : "الرسم البياني",
  visualizer_number : "متوسط",
  visualizer_choices : "جدول",
  visualizer_selectBase : "رسم بياني",
  chartType_bar : "شريط",
  chartType_vbar : "شريط عمودي",
  chartType_stackedbar : "شريط مكدس",
  chartType_doughnut : "Doughnut",
  chartType_pie : "Pie",
  chartType_scatter : "Scatter",
  chartType_gauge : "Gauge",
  chartType_bullet : "Bullet",
  hideButton : "اخفاء",
  makePrivateButton : "أجعل خاص",
  makePublicButton : "أجعل عام",
  showButton : "اظهار",
  filter : "ترشح",
  resetFilter : "إعادة تعيين",
  changeLocale : "تغيير اللغة",
  en : "اللغة الانجليزية",
  fr : "اللغه الفرنسية",
  ru : "اللغه الروسية",
  de : "اللغه الانجليزية",
  clearButton : "مسح",
  addElement : "اختر سؤالاً للعرض ...",
  defaultOrder : "الترتيب الافتراضي",
  ascOrder : "تصاعدى",
  descOrder : "تنازلى",
  showMinorColumns : "إظهار الأعمدة الثانوية",
  otherCommentTitle : "بنود وتعليقات أخرى",
  showPercentages : "عرض النسب المئوية",
  hidePercentages : "إخفاء النسب",
  pdfDownloadCaption : "PDF",
  xlsxDownloadCaption : "Excel",
  csvDownloadCaption : "CSV",
  saveDiagramAsPNG : "تنزيل بصيغة png",
  hideEmptyAnswers : "إخفاء الإجابات الفارغة",
  showEmptyAnswers : "إظهار الإجابات الفارغة",
  hideMissingAnswers : "إخفاء الإجابات المفقودة",
  showMissingAnswers : "عرض الإجابات المفقودة",
  missingAnswersLabel : "أجوبة مفقودة",
  noVisualizerForQuestion : "لم يتم العرض بعد",
  noResults : "لا يوجد نتائج للعرض",
  showPerValues : "لكل القيم",
  showPerColumns : "لكل الأعمدة",
  answer : "إجب",
  correctAnswer : "الاجابة الصحيحة: ",
  percent : "النسبه المئويه",
  responses : "الاستجابات",
};

localization.locales["ar"] = arabicStrings;
localization.localeNames["ar"] = "Arabic";
